export const config = () =>{
    return {
        API_URL:"https://www.ecilrapiscan.com/RAPService.asmx",
        UPLOAD_URL:"https://www.ecilrapiscan.com/"
    }
}
